<template>
    <b-row :class="{ 'my-3 border note': true, 'pinned': note.pinned, 'child': isChild }">
        <b-col>
            <div class="note-body d-flex flex-column">
                <div v-if="note.activityType === 0 || note.activityType">
                    <b-badge v-if="note.activityType === NoteActivityType.PhoneCall" variant="primary" class="mb-0">
                        <i class="fa fa-phone mr-1"></i>
                        Phone Call
                    </b-badge>
                    <b-badge v-if="note.activityType === NoteActivityType.TextMessage" variant="primary" class="mb-0">
                        <i class="fa fa-comment-dots mr-1"></i>
                        Text Message
                    </b-badge>
                    <b-badge v-if="note.activityType === NoteActivityType.Electronic" variant="primary" class="mb-0">
                        <i class="fa fa-at mr-1"></i>
                        Electronic
                    </b-badge>
                    <b-badge v-if="note.activityType === NoteActivityType.Portal" variant="primary" class="mb-0">
                        <i class="fa fa-wifi mr-1"></i>
                        Portal
                    </b-badge>
                    <b-badge v-if="note.activityType === NoteActivityType.Fax" variant="primary" class="mb-0">
                        <i class="fa fa-fax mr-1"></i>
                        Fax
                    </b-badge>
                </div>
                <div v-if="note.body?.trim()">
                    {{ note.body }}
                </div>
            </div>

            <div class="byline-bar d-flex">
                <div class="flex-fill cursor-pointer" @click="$emit('toggle-verbose-byline')">
                    <span :title="verboseByline ? undefined : note.createdBy">
                        {{ verboseByline ? note.createdBy : formatName(note.createdBy) }}
                    </span>
                    &middot;
                    <span :title="verboseByline ? relativeDate(note.created) : formatDate(note.created)">
                        {{ verboseByline ? formatDate(note.created) : relativeDate(note.created) }}
                    </span>
                </div>
                <div v-if="!isChild">
                    <a v-if="canPin" href="#" @click.prevent="$emit('toggle-pin')">
                        <i class="fas fa-thumbtack"></i>
                        {{ note.pinned ? "Unpin" : "Pin" }}
                    </a>
                    <a v-if="canReply" href="#" @click.prevent="$emit('reply')">
                        <i class="fas fa-reply"></i> Reply
                    </a>
                </div>
            </div>
        </b-col>
    </b-row>
</template>

<script lang="ts">

import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';
import { Note, NoteActivityType } from '@/models/Note';
import moment from "moment";

@Component({
    name: "NotesListItem",
    components: {}
})
export default class NotesListItem extends Vue {

    @Prop() private note!: Note;
    @Prop() private verboseByline!: boolean;
    @Prop({ default: true }) private canReply!: boolean;
    @Prop({ default: true }) private canPin!: boolean;

    get isChild() {
        return !!this.note.parentNoteId;
    }

    formatName(name: string) {
        if (name.includes("/")) return name.split("/")[1];
        if (name.includes("\\")) return name.split("\\")[1];
        return name.split("@")[0];
    }

    formatDate(date: Date) {
        return moment.utc(date).local().format("LLL");
    }

    relativeDate(date: Date) {
        return moment.utc(date).fromNow();
    }

    NoteActivityType = NoteActivityType;

}

</script>

<style scoped lang="scss">
.pinned {
    background: rgba(gold, .1);
    transition: all .2s;

    .byline-bar {
        background: rgba(white, .1);
    }
}

.note {
    border-radius: 0 15px 15px 15px;
    margin-bottom: 10px;
}

.child {
    border-radius: 15px 15px 0 15px;
    margin-top: 7px !important;
    margin-bottom: 5px !important;
}

.note-body {
    white-space: pre-wrap;
    line-height: 1.35;
    margin-top: 8px;
    gap: 6px;
}

.byline-bar {
    font-weight: 600;
    font-size: .75em;
    border-top: 1px solid rgba(black, 0.05);
    margin-left: -15px;
    margin-right: -15px;
    padding: 3px 5px;
    margin-top: 10px;
    padding-left: 15px;
    letter-spacing: .25px;

    a {
        padding: 5px;
    }
}
</style>
